var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gold"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1.1547C15.2376 0.44017 16.7624 0.44017 18 1.1547L27.8564 6.8453C29.094 7.55983 29.8564 8.88034 29.8564 10.3094V21.6906C29.8564 23.1197 29.094 24.4402 27.8564 25.1547L18 30.8453C16.7624 31.5598 15.2376 31.5598 14 30.8453L4.14359 25.1547C2.90599 24.4402 2.14359 23.1197 2.14359 21.6906V10.3094C2.14359 8.88034 2.90599 7.55983 4.14359 6.8453L14 1.1547Z",
    fill: "url(#paint0_radial_18323_25474)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4444 1.9245C15.407 1.36875 16.593 1.36875 17.5556 1.9245L27.412 7.6151C28.3745 8.17085 28.9675 9.19791 28.9675 10.3094V21.6906C28.9675 22.8021 28.3745 23.8292 27.412 24.3849L17.5556 30.0755C16.593 30.6312 15.407 30.6312 14.4444 30.0755L4.58804 24.3849C3.62546 23.8292 3.03248 22.8021 3.03248 21.6906V10.3094C3.03248 9.19791 3.62546 8.17085 4.58804 7.6151L14.4444 1.9245Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.77778
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18323_25474",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.3333 12) rotate(82.4054) scale(20.177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA933"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalGold);
export default __webpack_public_path__ + "static/media/medal-gold.9f95ae66b6d9dee316f6e797a8bbddac.svg";
export { ForwardRef as ReactComponent };